import React, { useState, useEffect } from 'react'
import {
  Panel,
  Form,
  FormGroup,
  Row,
  Col,
  ControlLabel,
  IconButton,
  Icon,
  SelectPicker,
  InputNumber,
  CheckboxGroup,
  Checkbox,
  RadioGroup,
  Radio,
  Input,
  Table,
  InputGroup,
  DatePicker,
} from 'rsuite'
import CustomIconMessageInfo from '../../../CustomIconMessageInfo'
import { isRequiredFiled, requiredFiled, isValidators } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import InputNumberForm from '../../../../components/forms/input/InputNumberForm'
import CKEditorFrom from '../../../../components/forms/input/CKEditorFrom'
import { startLoading, doneLoading } from '../../../../utils/loading'
import TooltipButton from '../../../../components/buttons/TooltipButton'
import moment from 'moment'
import NumberFormat from 'react-number-format'
import { DATE_FORMAT, LOCAL_DAY_TH } from '../../../../constants/date'
import { loadLocation } from '../../../../components/location/Location'
import OverlayLoader from '../../../../components/OverlayLoader/OverlayLoader'

export default function ReduceAlcoholBGForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
}) {
  const { Column, HeaderCell, Cell, ColumnGroup } = Table

  const [checkIsSolve, setCheckIsSolve] = useState(false)
  const [singleNganBoon, setSingleNganBoon] = useState([])
  const [othersSingleNganBoon, setOthersSingleNganBoon] = useState([])
  const [joinNganBoon, setJoinNganBoon] = useState([])
  const [othersJoinNganBoon, setOthersJoinNganBoon] = useState([])
  const [location, setLocation] = useState([])
  const [district, setDistrict] = useState([])
  const [subDistrict, setSubDistrict] = useState([])
  const [annualFestival, setAnnualFestival] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    // console.log('useEffect', schema)
    handleLocation()

    // typeAndNumOfEvent
    if (schema.singleNganBoonOtherEvents && schema.singleNganBoonOtherEvents.eventList) {
      let singleNganBoonOtherEvents = schema.singleNganBoonOtherEvents.eventList.map((item) => {
        return item
      })
      setOthersJoinNganBoon(singleNganBoonOtherEvents)
      setValue(schema.singleNganBoonOtherEvents.name, singleNganBoonOtherEvents)
    }

    if (schema.singleNganBoon && schema.singleNganBoon.eventList) {
      let singleNganBoon = schema.singleNganBoon.eventList.map((item) => {
        return item
      })
      setSingleNganBoon(singleNganBoon)
      setValue(schema.singleNganBoon.name, singleNganBoon)
    }

    if (schema.joinNganBoonOtherEvents && schema.joinNganBoonOtherEvents.eventList) {
      let joinNganBoonOtherEvents = schema.joinNganBoonOtherEvents.eventList.map((item) => {
        return item
      })
      setOthersSingleNganBoon(joinNganBoonOtherEvents)
      setValue(schema.joinNganBoonOtherEvents.name, joinNganBoonOtherEvents)
    }

    if (schema.joinNganBoon && schema.joinNganBoon.eventList) {
      let joinNganBoon = schema.joinNganBoon.eventList.map((item) => {
        return item
      })
      setJoinNganBoon(joinNganBoon)
      setValue(schema.joinNganBoon.name, joinNganBoon)
    }

    schema.alcoholProblemSolution &&
      schema.alcoholProblemSolution.value === 'Y' &&
      setCheckIsSolve(true)

    setAnnualFestival(schema?.annualFestival?.values || [])

    // handledDistrictSubDistrict(schema)
  }, [schema])

  useEffect(() => {
    // console.log('useEffect location : ', location)
    handledDistrictSubDistrict(schema)
  }, [location])

  const handledDistrictSubDistrict = async (schema) => {
    startLoading()
    let location = localStorage.getItem('location')
    // console.log('location : ', location)
    let locationData = location ? JSON.parse(location) : []
    // console.log('locationData : ', locationData)
    if (schema.province.value) {
      let district = locationData?.find((obj) => obj.value === schema.province.value).children || []
      let subDistrict = district?.find((obj) => obj.value === schema.district.value).children || []

      setDistrict(district)
      setSubDistrict(subDistrict)
    }

    doneLoading()
  }

  const handleLocation = async () => {
    setIsLoading(true)
    const location = await loadLocation()
    setLocation(location)
    setIsLoading(false)
  }

  const removeOthersSingleNganBoon = (index) => {
    let array = [...othersSingleNganBoon]
    array.splice(index, 1)
    console.log('removeOthersSingleNganBoon', array)
    setOthersSingleNganBoon(array)
    setValue(schema.singleNganBoonOtherEvents.name, array)
  }

  const addOthersSingleNganBoon = () => {
    let otherNganBoon = {
      event: '',
      totalEvent: '',
      noAlcoholEvent: '',
      alcoholEvent: '',
      totalAlcoholCost: '',
    }

    let array = [...othersSingleNganBoon]
    array.push(otherNganBoon)

    setOthersSingleNganBoon(array)
    setValue(schema.singleNganBoonOtherEvents.name, array)
  }

  const removeOthersJoinNganBoon = (index) => {
    let array = [...othersJoinNganBoon]
    array.splice(index, 1)
    console.log('removeOthersJoinNganBoon', array)
    setOthersJoinNganBoon(array)
    setValue(schema.joinNganBoonOtherEvents.name, array)
  }

  const addOthersJoinNganBoon = () => {
    let otherNganBoon = {
      event: '',
      totalEvent: '',
      noAlcoholEvent: '',
      alcoholEvent: '',
      totalAlcoholCost: '',
    }

    let array = [...othersJoinNganBoon]
    array.push(otherNganBoon)

    setOthersJoinNganBoon(array)
    setValue(schema.joinNganBoonOtherEvents.name, array)
  }

  const addAnnualFestival = () => {
    let array = [...annualFestival]
    array.push({
      festivalName: '',
      festivalDate: '',
    })

    setAnnualFestival(array)
    setValue(schema.annualFestival.name, array)
  }

  const deleteAnnualFestival = (index) => {
    let array = [...annualFestival]
    array.splice(index, 1)

    console.log('array', array)

    setAnnualFestival(array)
    setValue(schema.annualFestival.name, array)
  }

  const onChangeAnnualFestival = (value, index, field) => {
    // console.log('value', value, 'index', index, 'field', field)
    let array = [...annualFestival]
    array[index][field] = value
    setAnnualFestival(array)
    setValue(schema.annualFestival.name, array)
  }

  const checkBoxOneInput = (selectedList, obj) => {
    // console.log('errors', errors)
    return (
      <div style={{ display: 'flex', marginTop: '3px' }}>
        <Checkbox
          value={obj.name}
          onChange={(value, checked) => {
            console.log('checkBoxOneInput value', value)
            if (!checked) {
              setValue(value)
              clearErrors(value)
            }
          }}
        >
          {obj.label}
        </Checkbox>
        {selectedList && selectedList.includes(obj.name) && (
          <InputGroup style={{ position: 'absolute', marginLeft: '300px' }}>
            <InputGroup.Addon>{isRequiredFiled(true, obj.preLabel)}</InputGroup.Addon>
            <Controller
              key={obj.name}
              name={obj.name}
              control={control}
              // rules={isValidators(obj.validators)}
              rules={{
                required: 'กรุณากรอก ' + obj.preLabel,
              }}
              defaultValue={obj.value}
              render={(props) => {
                return (
                  <NumberFormat
                    className="rs-input"
                    thousandSeparator={true}
                    defaultValue={props.value}
                    placeholder={obj.preLabel + obj.postLabel}
                    onValueChange={(e) => {
                      props.onChange(e.floatValue)
                    }}
                  />
                )
              }}
            />
            <InputGroup.Addon>
              <p style={{ width: '50px' }}>{obj.postLabel}</p>
            </InputGroup.Addon>
          </InputGroup>
        )}
      </div>
    )
  }

  const nganBoonEventInput = (schemaObj, type, dfValue, index) => {
    const keyName = type + '_' + index + '_' + schemaObj.name
    return (
      <Row>
        {errors[keyName] && (
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
            <ErrorMessage error={errors[keyName]} />
          </Col>
        )}

        {schemaObj.label && (
          <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 5 }}>
            <p style={{ marginTop: 5 }}>{requiredFiled(schemaObj.validators, schemaObj.label)}</p>
          </Col>
        )}
        <Col xs={24} sm={24} md={16} lg={16} style={{ marginTop: 5 }}>
          <InputGroup>
            {schemaObj.preLabel && <InputGroup.Addon>{schemaObj.preLabel}</InputGroup.Addon>}
            <Controller
              key={keyName}
              name={keyName}
              control={control}
              rules={isValidators(schemaObj.validators)}
              defaultValue={dfValue}
              render={(props) => {
                return (
                  // <InputNumber
                  //   min={0}
                  //   value={props.value}
                  //   style={{ width: 150 }}
                  //   placeholder={schemaObj.hint}
                  //   onChange={(value) => {
                  // console.log('type', type, 'value', value)
                  <NumberFormat
                    className="rs-input"
                    thousandSeparator={true}
                    defaultValue={props.value}
                    placeholder={schemaObj.hint || schemaObj.label}
                    onValueChange={(e) => {
                      let value = e.floatValue
                      let list = []
                      switch (type) {
                        case schema.joinNganBoon.name:
                          list = [...joinNganBoon]
                          break
                        case schema.joinNganBoonOtherEvents.name:
                          list = [...othersJoinNganBoon]
                          break
                        case schema.singleNganBoon.name:
                          list = [...singleNganBoon]
                          break
                        case schema.singleNganBoonOtherEvents.name:
                          list = [...othersSingleNganBoon]
                          break
                        default:
                          break
                      }

                      list[index][schemaObj.name] = value
                      // console.log(list)
                      setValue(type, list)
                      setValue(keyName, value)
                      clearErrors(keyName)
                    }}
                  />
                )
              }}
            />
            {schemaObj.postLabel && (
              <InputGroup.Addon>
                <p style={{ width: 50 }}>{schemaObj.postLabel}</p>
              </InputGroup.Addon>
            )}
          </InputGroup>
        </Col>
      </Row>
    )
  }

  const nganBoonController = () => {
    return (
      <>
        <Controller
          key={schema.singleNganBoon.name}
          name={schema.singleNganBoon.name}
          control={control}
          defaultValue={singleNganBoon}
        />
        <Controller
          key={schema.singleNganBoonOtherEvents.name}
          name={schema.singleNganBoonOtherEvents.name}
          control={control}
          defaultValue={othersSingleNganBoon}
        />

        <Controller
          key={schema.joinNganBoon.name}
          name={schema.joinNganBoon.name}
          control={control}
          defaultValue={joinNganBoon}
        />
        <Controller
          key={schema.joinNganBoonOtherEvents.name}
          name={schema.joinNganBoonOtherEvents.name}
          control={control}
          defaultValue={othersJoinNganBoon}
        />
      </>
    )
  }

  return (
    <>
      {schema.communityBackground && (
        <Panel header={schema.communityBackground.label}>
          {nganBoonController()}
          <Form fluid>
            <FormGroup>
              <p style={{ fontWeight: 550 }}>
                <b>{schema.basicInfo.label}</b>
              </p>
              <InputNumberForm
                schema={schema.censusHousehold}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                labelMdLg={6}
                inputMdlg={18}
              />
              <InputNumberForm
                schema={schema.realHousehold}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                labelMdLg={6}
                inputMdlg={18}
              />
              <InputNumberForm
                schema={schema.censusPopulation}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                labelMdLg={6}
                inputMdlg={18}
              />
              <InputNumberForm
                schema={schema.realPopulation}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                labelMdLg={6}
                inputMdlg={18}
              />
              <br />
              <br />
              {/* {alcoholDrink && ( */}
              <div>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                    <ControlLabel style={{ fontWeight: 550 }}>
                      {requiredFiled(
                        schema.alcoholDrinkProvince.validators,
                        schema.alcoholDrink.label
                      )}
                    </ControlLabel>
                    <CustomIconMessageInfo contents={schema.alcoholDrink.description} />
                    <ErrorMessage error={errors[schema.alcoholDrinkProvince.name]} />
                    <Controller
                      key={schema.alcoholDrinkProvince.name}
                      name={schema.alcoholDrinkProvince.name}
                      control={control}
                      rules={isValidators(schema.alcoholDrinkProvince.validators)}
                      defaultValue={schema.alcoholDrinkProvince.value}
                      render={(props) => {
                        return (
                          <SelectPicker
                            size="lg"
                            data={location}
                            style={{ width: 200 }}
                            value={props.value}
                            placeholder={schema.alcoholDrinkProvince.hint}
                            onChange={(e) => {
                              setValue(schema.alcoholDrinkProvince.name, e)
                              clearErrors(schema.alcoholDrinkProvince.name)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                    <ControlLabel style={{ fontWeight: 550 }}>
                      {requiredFiled(schema.ranking.validators, schema.ranking.label)}
                    </ControlLabel>
                    <ErrorMessage error={errors[schema.ranking.name]} />
                    <Controller
                      key={schema.ranking.name}
                      name={schema.ranking.name}
                      control={control}
                      rules={isValidators(schema.ranking.validators)}
                      defaultValue={schema.ranking.value}
                      render={(props) => {
                        return (
                          <NumberFormat
                            className="rs-input"
                            placeholder={schema.ranking.hint || schema.ranking.label}
                            style={{ width: 200 }}
                            thousandSeparator={true}
                            value={props.value}
                            onValueChange={(e) => {
                              props.onChange(e.floatValue)
                            }}
                          />
                        )
                      }}
                    />
                  </Col>
                </Row>
              </div>
              {/* )} */}

              <br />
              <br />
              {/* {schema.alcoholProblem && ( */}
              <div>
                <CKEditorFrom
                  schema={schema.alcoholProblem}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
              </div>
              {/* )} */}

              <br />
              <br />
              {/* {alcoholDrinker && ( */}
              <div>
                <p style={{ fontWeight: 550 }}>{schema.alcoholDrinker.label}</p>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
                    <ErrorMessage error={errors[schema.lowCount.name]} />
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 10 }}>
                    {requiredFiled(schema.lowCount.validators, schema.lowCount.label)}
                  </Col>
                  <Col xs={24} sm={24} md={16} lg={16} style={{ marginTop: 5 }}>
                    <div style={{ display: 'flex' }}>
                      <InputGroup>
                        <InputGroup.Addon>{schema.lowCount.preLabel}</InputGroup.Addon>
                        <Controller
                          key={schema.lowCount.name}
                          name={schema.lowCount.name}
                          control={control}
                          rules={isValidators(schema.lowCount.validators)}
                          defaultValue={schema.lowCount.value}
                          render={(props) => {
                            return (
                              <NumberFormat
                                className="rs-input"
                                placeholder={schema.lowCount.hint || schema.lowCount.label}
                                style={{ width: '150px' }}
                                thousandSeparator={true}
                                defaultValue={props.value}
                                onValueChange={(e) => {
                                  props.onChange(e.floatValue)
                                }}
                              />
                            )
                          }}
                        />
                        <InputGroup.Addon>
                          <p style={{ width: '50px' }}>{schema.lowCount.postLabel}</p>
                        </InputGroup.Addon>
                      </InputGroup>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
                    <ErrorMessage error={errors[schema.normalCount.name]} />
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 10 }}>
                    {requiredFiled(schema.normalCount.validators, schema.normalCount.label)}
                  </Col>
                  <Col xs={24} sm={24} md={16} lg={16} style={{ marginTop: 5 }}>
                    <div style={{ display: 'flex' }}>
                      <InputGroup>
                        <InputGroup.Addon>{schema.normalCount.preLabel}</InputGroup.Addon>
                        <Controller
                          key={schema.normalCount.name}
                          name={schema.normalCount.name}
                          control={control}
                          rules={isValidators(schema.normalCount.validators)}
                          defaultValue={schema.normalCount.value}
                          render={(props) => {
                            return (
                              <NumberFormat
                                className="rs-input"
                                placeholder={schema.normalCount.hint || schema.normalCount.label}
                                style={{ width: '150px' }}
                                thousandSeparator={true}
                                defaultValue={props.value}
                                onValueChange={(e) => {
                                  props.onChange(e.floatValue)
                                }}
                              />
                            )
                          }}
                        />
                        <InputGroup.Addon>
                          <p style={{ width: '50px' }}>{schema.normalCount.postLabel}</p>
                        </InputGroup.Addon>
                      </InputGroup>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
                    <ErrorMessage error={errors[schema.highCount.name]} />
                  </Col>
                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 10 }}>
                    {requiredFiled(schema.highCount.validators, schema.highCount.label)}
                  </Col>
                  <Col xs={24} sm={24} md={16} lg={16} style={{ marginTop: 5 }}>
                    <div style={{ display: 'flex' }}>
                      <InputGroup>
                        <InputGroup.Addon>{schema.highCount.preLabel}</InputGroup.Addon>
                        <Controller
                          key={schema.highCount.name}
                          name={schema.highCount.name}
                          control={control}
                          rules={isValidators(schema.highCount.validators)}
                          defaultValue={schema.highCount.value}
                          render={(props) => {
                            return (
                              <NumberFormat
                                className="rs-input"
                                placeholder={schema.highCount.hint || schema.highCount.label}
                                style={{ width: '150px' }}
                                thousandSeparator={true}
                                defaultValue={props.value}
                                onValueChange={(e) => {
                                  props.onChange(e.floatValue)
                                }}
                              />
                            )
                          }}
                        />
                        <InputGroup.Addon>
                          <p style={{ width: '50px' }}>{schema.highCount.postLabel}</p>
                        </InputGroup.Addon>
                      </InputGroup>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col style={{ marginTop: 5 }}>
                    <ErrorMessage error={errors[schema.drinkerDatasource.name]} />
                  </Col>
                  <Col style={{ marginTop: 10 }}>
                    {requiredFiled(
                      schema.drinkerDatasource.validators,
                      schema.drinkerDatasource.hint
                    )}
                  </Col>
                  <Col style={{ marginTop: 5 }}>
                    <div style={{ display: 'flex' }}>
                      <Input
                        name={schema.drinkerDatasource.name}
                        placeholder={schema.drinkerDatasource.hint}
                        inputRef={register(isValidators(schema.drinkerDatasource.validators))}
                        defaultValue={schema.drinkerDatasource.value}
                        style={{ marginLeft: 10 }}
                      />
                    </div>
                  </Col>
                </Row>
              </div>
              {/* )} */}

              <br />
              <br />

              {schema.alcoholShop && (
                <div>
                  <p style={{ fontWeight: 550 }}>{schema.alcoholShop.label}</p>
                  {schema.alcoholShop.introduction && (
                    <div dangerouslySetInnerHTML={{ __html: schema.alcoholShop.introduction }} />
                  )}

                  <InputNumberForm
                    schema={schema.allComplyAct}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={6}
                    inputMdlg={18}
                  ></InputNumberForm>
                  <InputNumberForm
                    schema={schema.someComplyAct}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={6}
                    inputMdlg={18}
                  ></InputNumberForm>
                  <InputNumberForm
                    schema={schema.neverComplyAct}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    labelMdLg={6}
                    inputMdlg={18}
                  ></InputNumberForm>
                </div>
              )}

              <br />
              <br />
              {schema.alcoholDrinkingProblems && (
                <div>
                  <ControlLabel>
                    <span style={{ fontWeight: 550 }}>
                      {requiredFiled(
                        schema.alcoholDrinkingProblems.validators,
                        schema.alcoholDrinkingProblems.label
                      )}
                    </span>
                  </ControlLabel>
                  <Controller
                    key={schema.alcoholDrinkingProblems.name}
                    name={schema.alcoholDrinkingProblems.name}
                    control={control}
                    rules={isValidators(schema.alcoholDrinkingProblems.validators)}
                    defaultValue={schema.alcoholDrinkingProblems.value}
                    render={(props) => {
                      return (
                        <>
                          <CheckboxGroup
                            name="checkboxList"
                            defaultValue={props.value}
                            onChange={(val) => {
                              if (val.length < 1) {
                                setValue(schema.alcoholDrinkingDetail.name)
                                clearErrors(schema.alcoholDrinkingDetail.name)
                              }
                              setValue(schema.alcoholDrinkingProblems.name, val)
                            }}
                          >
                            <ErrorMessage error={errors[schema.alcoholDrinkingFight.name]} />
                            {checkBoxOneInput(props.value, schema.alcoholDrinkingFight)}
                            <ErrorMessage error={errors[schema.alcoholDrinkingAccident.name]} />
                            {checkBoxOneInput(props.value, schema.alcoholDrinkingAccident)}
                            <ErrorMessage error={errors[schema.alcoholDrinkingIllness.name]} />
                            {checkBoxOneInput(props.value, schema.alcoholDrinkingIllness)}
                            <ErrorMessage error={errors[schema.alcoholDrinkingDebt.name]} />
                            {checkBoxOneInput(props.value, schema.alcoholDrinkingDebt)}
                          </CheckboxGroup>
                          {props.value && props.value.length > 0 && (
                            <div style={{ marginLeft: 10, marginTop: 10 }}>
                              <CKEditorFrom
                                schema={schema.alcoholDrinkingDetail}
                                register={register}
                                Controller={Controller}
                                control={control}
                                errors={errors}
                                setValue={setValue}
                                clearErrors={clearErrors}
                              />
                            </div>
                          )}
                        </>
                      )
                    }}
                  />
                </div>
              )}

              <br />
              <br />

              {schema.typeAndNumOfEvent && (
                <div>
                  <p style={{ fontWeight: 550 }}>{schema.typeAndNumOfEvent.label}</p>

                  <div style={{ marginLeft: '20px', marginTop: 10 }}>
                    <p style={{ fontWeight: 550 }}>{schema.joinNganBoon.label}</p>

                    {schema.joinNganBoon &&
                      schema.joinNganBoon.eventList.map((item, index) => {
                        return (
                          <div style={{ marginLeft: '20px', marginTop: 10 }}>
                            <p style={{ fontWeight: 550 }}>{item.event}</p>
                            <div style={{ marginLeft: '20px', marginTop: 10 }}>
                              {nganBoonEventInput(
                                schema.eventSchema.totalEvent,
                                schema.joinNganBoon.name,
                                item.totalEvent,
                                index
                              )}
                              {nganBoonEventInput(
                                schema.eventSchema.noAlcoholEvent,
                                schema.joinNganBoon.name,
                                item.noAlcoholEvent,
                                index
                              )}
                              {nganBoonEventInput(
                                schema.eventSchema.alcoholEvent,
                                schema.joinNganBoon.name,
                                item.alcoholEvent,
                                index
                              )}
                              {nganBoonEventInput(
                                schema.eventSchema.totalAlcoholCost,
                                schema.joinNganBoon.name,
                                item.totalAlcoholCost,
                                index
                              )}
                            </div>
                          </div>
                        )
                      })}

                    {schema.joinNganBoonOtherEvents && (
                      <>
                        <div style={{ marginLeft: '20px', marginTop: 10 }}>
                          <p style={{ fontWeight: 550 }}>{schema.joinNganBoonOtherEvents.label}</p>
                          {othersJoinNganBoon.map((item, index) => {
                            return (
                              <div style={{ marginLeft: '20px', marginTop: 10 }}>
                                <Row>
                                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
                                    <ErrorMessage
                                      error={
                                        errors[
                                          schema.joinNganBoonOtherEvents.name +
                                            '_' +
                                            index +
                                            '_' +
                                            schema.eventSchema.event.name
                                        ]
                                      }
                                    />
                                  </Col>
                                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 5 }}>
                                    <p style={{ fontWeight: 550 }}>
                                      {isRequiredFiled(true, schema.eventSchema.event.label)}
                                    </p>
                                  </Col>
                                  <Col xs={24} sm={24} md={16} lg={16} style={{ marginTop: 5 }}>
                                    <div style={{ display: 'flex' }}>
                                      <Input
                                        name={
                                          schema.joinNganBoonOtherEvents.name +
                                          '_' +
                                          index +
                                          '_' +
                                          schema.eventSchema.event.name
                                        }
                                        style={{ width: '300px' }}
                                        defaultValue={item.event}
                                        inputRef={register({ required: 'กรุณากรอก ข้อมูล' })}
                                        onChange={(value) => {
                                          let list = [...othersJoinNganBoon]
                                          list[index][schema.eventSchema.event.name] = value
                                          console.log(list)
                                          setValue(schema.joinNganBoonOtherEvents.name, list)
                                        }}
                                      ></Input>
                                    </div>
                                  </Col>
                                </Row>
                                {nganBoonEventInput(
                                  schema.eventSchema.totalEvent,
                                  schema.joinNganBoonOtherEvents.name,
                                  item.totalEvent,
                                  index
                                )}
                                {nganBoonEventInput(
                                  schema.eventSchema.noAlcoholEvent,
                                  schema.joinNganBoonOtherEvents.name,
                                  item.noAlcoholEvent,
                                  index
                                )}
                                {nganBoonEventInput(
                                  schema.eventSchema.alcoholEvent,
                                  schema.joinNganBoonOtherEvents.name,
                                  item.alcoholEvent,
                                  index
                                )}
                                {nganBoonEventInput(
                                  schema.eventSchema.totalAlcoholCost,
                                  schema.joinNganBoonOtherEvents.name,
                                  item.totalAlcoholCost,
                                  index
                                )}
                                <IconButton
                                  appearance="ghost"
                                  className="rs-btn-ghost-cancel"
                                  style={{ width: '100px', marginLeft: 5 }}
                                  onClick={() => {
                                    removeOthersJoinNganBoon(index)
                                  }}
                                  icon={
                                    <Icon
                                      appearance="ghost"
                                      icon="minus"
                                      className="bt-gost-icon-radius-cancel"
                                    />
                                  }
                                >
                                  ลบ
                                </IconButton>
                              </div>
                            )
                          })}

                          <div style={{ marginLeft: '20px', marginTop: 10 }}>
                            <IconButton
                              appearance="ghost"
                              style={{ width: '100px' }}
                              onClick={addOthersJoinNganBoon}
                              icon={
                                <Icon
                                  appearance="ghost"
                                  icon="plus"
                                  className="bt-gost-icon-radius"
                                />
                              }
                            >
                              เพิ่มงาน
                            </IconButton>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <br />
                  <div style={{ marginLeft: '20px', marginTop: 10 }}>
                    <p style={{ fontWeight: 550 }}>{schema.singleNganBoon.label}</p>
                    {schema.singleNganBoon &&
                      schema.singleNganBoon.eventList.map((item, index) => {
                        return (
                          <div style={{ marginLeft: '20px', marginTop: 10 }}>
                            <p style={{ fontWeight: 550 }}>{item.event}</p>
                            <div style={{ marginLeft: '20px', marginTop: 10 }}>
                              {nganBoonEventInput(
                                schema.eventSchema.totalEvent,
                                schema.singleNganBoon.name,
                                item.totalEvent,
                                index
                              )}
                              {nganBoonEventInput(
                                schema.eventSchema.noAlcoholEvent,
                                schema.singleNganBoon.name,
                                item.noAlcoholEvent,
                                index
                              )}
                              {nganBoonEventInput(
                                schema.eventSchema.alcoholEvent,
                                schema.singleNganBoon.name,
                                item.alcoholEvent,
                                index
                              )}
                              {nganBoonEventInput(
                                schema.eventSchema.totalAlcoholCost,
                                schema.singleNganBoon.name,
                                item.totalAlcoholCost,
                                index
                              )}
                            </div>
                          </div>
                        )
                      })}

                    {schema.singleNganBoonOtherEvents && (
                      <>
                        <div style={{ marginLeft: '20px', marginTop: 10 }}>
                          <p style={{ fontWeight: 550 }}>
                            {schema.singleNganBoonOtherEvents.label}
                          </p>
                          {othersSingleNganBoon.map((item, index) => {
                            return (
                              <div style={{ marginLeft: '20px', marginTop: 10 }}>
                                <Row>
                                  <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 5 }}>
                                    <ErrorMessage
                                      error={
                                        errors[
                                          schema.singleNganBoonOtherEvents.name +
                                            '_' +
                                            index +
                                            '_' +
                                            schema.eventSchema.event.name
                                        ]
                                      }
                                    />
                                  </Col>
                                  <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 5 }}>
                                    <p style={{ fontWeight: 550 }}>
                                      {isRequiredFiled(true, schema.eventSchema.event.label)}
                                    </p>
                                  </Col>
                                  <Col xs={24} sm={24} md={16} lg={16} style={{ marginTop: 5 }}>
                                    <div style={{ display: 'flex' }}>
                                      <Input
                                        name={
                                          schema.singleNganBoonOtherEvents.name +
                                          '_' +
                                          index +
                                          '_' +
                                          schema.eventSchema.event.name
                                        }
                                        style={{ width: '300px' }}
                                        defaultValue={item.event}
                                        inputRef={register({ required: 'กรุณากรอก ข้อมูล' })}
                                        onChange={(value) => {
                                          let list = [...othersSingleNganBoon]
                                          list[index][schema.eventSchema.event.name] = value
                                          // console.log(list)
                                          setValue(schema.singleNganBoonOtherEvents.name, list)
                                        }}
                                      ></Input>
                                    </div>
                                  </Col>
                                </Row>
                                {nganBoonEventInput(
                                  schema.eventSchema.totalEvent,
                                  schema.singleNganBoonOtherEvents.name,
                                  item.totalEvent,
                                  index
                                )}
                                {nganBoonEventInput(
                                  schema.eventSchema.noAlcoholEvent,
                                  schema.singleNganBoonOtherEvents.name,
                                  item.noAlcoholEvent,
                                  index
                                )}
                                {nganBoonEventInput(
                                  schema.eventSchema.alcoholEvent,
                                  schema.singleNganBoonOtherEvents.name,
                                  item.alcoholEvent,
                                  index
                                )}
                                {nganBoonEventInput(
                                  schema.eventSchema.totalAlcoholCost,
                                  schema.singleNganBoonOtherEvents.name,
                                  item.totalAlcoholCost,
                                  index
                                )}
                                <IconButton
                                  appearance="ghost"
                                  className="rs-btn-ghost-cancel"
                                  style={{ width: '100px', marginLeft: 5 }}
                                  onClick={() => {
                                    removeOthersSingleNganBoon(index)
                                  }}
                                  icon={
                                    <Icon
                                      appearance="ghost"
                                      icon="minus"
                                      className="bt-gost-icon-radius-cancel"
                                    />
                                  }
                                >
                                  ลบ
                                </IconButton>
                              </div>
                            )
                          })}

                          <div style={{ marginLeft: '20px', marginTop: 10 }}>
                            <IconButton
                              appearance="ghost"
                              style={{ width: '100px' }}
                              onClick={addOthersSingleNganBoon}
                              icon={
                                <Icon
                                  appearance="ghost"
                                  icon="plus"
                                  className="bt-gost-icon-radius"
                                />
                              }
                            >
                              เพิ่มงาน
                            </IconButton>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}

              <br />
              <br />
              {schema.alcoholProblemSolution && (
                <div>
                  <p style={{ fontWeight: 550 }}>
                    {requiredFiled(
                      schema.alcoholProblemSolution.validators,
                      schema.alcoholProblemSolution.label
                    )}
                  </p>
                  <Controller
                    key={schema.alcoholProblemSolution.name}
                    name={schema.alcoholProblemSolution.name}
                    control={control}
                    rules={isValidators(schema.alcoholProblemSolution.validators)}
                    defaultValue={schema.alcoholProblemSolution.value}
                    render={(props) => {
                      return (
                        <RadioGroup
                          inline
                          name="radioList"
                          defaultValue={props.value}
                          onChange={(val) => {
                            val == 'Y' ? setCheckIsSolve(true) : setCheckIsSolve(false)
                            setValue(schema.alcoholProblemSolution.name, val)
                          }}
                        >
                          {schema.alcoholProblemSolution.options.map((item) => {
                            return <Radio value={item.value}>{item.label}</Radio>
                          })}
                        </RadioGroup>
                      )
                    }}
                  />

                  {checkIsSolve && (
                    <div style={{ marginLeft: 10 }}>
                      <CKEditorFrom
                        schema={schema.alcoholProblemSubject}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      ></CKEditorFrom>

                      <CKEditorFrom
                        schema={schema.alcoholProblemSolving}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      ></CKEditorFrom>

                      <CKEditorFrom
                        schema={schema.alcoholProblemSolveResult}
                        register={register}
                        Controller={Controller}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        clearErrors={clearErrors}
                      ></CKEditorFrom>
                    </div>
                  )}
                </div>
              )}

              <br />
              <br />
              {schema.strengthWeakness && (
                <div>
                  <CKEditorFrom
                    schema={schema.strengthWeakness}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </div>
              )}

              <br />
              <br />
              {schema.annualFestival && (
                <div>
                  <p style={{ fontWeight: 550 }}>{schema.annualFestival.label}</p>
                  <Controller
                    key={schema.annualFestival.name}
                    name={schema.annualFestival.name}
                    control={control}
                    rules={isValidators(schema.annualFestival.validators)}
                    defaultValue={annualFestival}
                  ></Controller>
                  <Table
                    data={annualFestival}
                    wordWrap={true}
                    bordered
                    autoHeight
                    style={{ marginTop: 10 }}
                  >
                    <Column minWidth={250} flexGrow={1}>
                      <HeaderCell>{schema.festivalName.label}</HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          let name = schema.festivalName.name + '_' + index
                          return (
                            <>
                              <ErrorMessage error={errors[name]} />
                              <Input
                                name={name}
                                disabled={schema.festivalName.disabled}
                                value={rowData.festivalName}
                                inputRef={register(isValidators(schema.festivalName.validators))}
                                onChange={(value) => {
                                  onChangeAnnualFestival(value, index, schema.festivalName.name)
                                }}
                              />
                            </>
                          )
                        }}
                      </Cell>
                    </Column>

                    <Column width={170} align="center">
                      <HeaderCell>{schema.festivalDate.label}</HeaderCell>
                      <Cell>
                        {(rowData, index) => {
                          let name = schema.festivalDate.name + '_' + index
                          return (
                            <>
                              <ErrorMessage error={errors[name]} />
                              <Controller
                                key={name}
                                name={name}
                                control={control}
                                rules={isValidators(schema.festivalDate.validators)}
                                defaultValue={rowData.festivalDate}
                                render={(props) => {
                                  return (
                                    <DatePicker
                                      size="lg"
                                      format={DATE_FORMAT}
                                      locale={LOCAL_DAY_TH}
                                      block
                                      placement="auto"
                                      disabled={schema.festivalDate.disabled}
                                      value={rowData.festivalDate}
                                      onChange={(value) => {
                                        let date
                                        // value && (date = value.toLocaleDateString('en-ZA'))
                                        value && (date = moment(value).format(DATE_FORMAT))
                                        console.log('date', date)
                                        onChangeAnnualFestival(
                                          date,
                                          index,
                                          schema.festivalDate.name
                                        )
                                        setValue(name, date)
                                        clearErrors(name)
                                      }}
                                      onClean={() => {
                                        setValue(name)
                                        onChangeAnnualFestival('', index, schema.festivalDate.name)
                                      }}
                                    />
                                  )
                                }}
                              ></Controller>
                            </>
                          )
                        }}
                      </Cell>
                    </Column>
                    <Column width={60} align="center" fixed="right">
                      <HeaderCell></HeaderCell>
                      <Cell>
                        {(_, index) => {
                          return (
                            <TooltipButton
                              icon="trash"
                              tooltip={`ลบข้อมูลงานบุญ`}
                              onClick={() => deleteAnnualFestival(index)}
                            ></TooltipButton>
                          )
                        }}
                      </Cell>
                    </Column>
                  </Table>
                  <Row style={{ marginTop: 10 }}>
                    <IconButton
                      appearance="ghost"
                      onClick={addAnnualFestival}
                      icon={<Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />}
                    >
                      เพิ่มข้อมูลงานบุญ
                    </IconButton>
                  </Row>
                </div>
              )}

              <Row style={{ marginTop: 20 }}>
                <ErrorMessage error={errors[schema.village.name]} />
                {requiredFiled(schema.village.validators, schema.village.label)}
                <Input
                  name={schema.village.name}
                  disabled={schema.village.disabled}
                  defaultValue={schema.village.value}
                  placeholder={schema.village.hint || schema.village.label}
                  inputRef={register(isValidators(schema.village.validators))}
                />
              </Row>
              <Row style={{ marginTop: 10 }}>
                <Col xs={24} sm={24} md={8} lg={8}>
                  <ErrorMessage error={errors[schema.province.name]} />
                  <ControlLabel>
                    {requiredFiled(schema.province.validators, schema.province.label)}
                  </ControlLabel>
                  <Controller
                    key={schema.province.name}
                    name={schema.province.name}
                    control={control}
                    rules={isValidators(schema.province.validators)}
                    defaultValue={schema.province.value}
                    render={(props) => {
                      return (
                        <SelectPicker
                          size="lg"
                          data={location}
                          style={{ width: '100%' }}
                          value={props.value}
                          placeholder={`เลือก${schema.province.label}`}
                          onSelect={(value, obj) => {
                            props.onChange(value)
                            setDistrict(obj.children || [])
                            setSubDistrict([])
                          }}
                        />
                      )
                    }}
                  />
                </Col>
                <Col xs={24} sm={24} md={8} lg={8}>
                  <ErrorMessage error={errors[schema.district.name]} />
                  <ControlLabel>
                    {requiredFiled(schema.district.validators, schema.district.label)}
                  </ControlLabel>
                  <Controller
                    key={schema.district.name}
                    name={schema.district.name}
                    control={control}
                    rules={isValidators(schema.district.validators)}
                    defaultValue={schema.district.value}
                    render={(props) => {
                      return (
                        <SelectPicker
                          size="lg"
                          data={district}
                          style={{ width: '100%' }}
                          value={props.value}
                          placeholder={`เลือก${schema.district.label}`}
                          onSelect={(value, obj) => {
                            props.onChange(value)
                            setSubDistrict(obj.children || [])
                          }}
                        />
                      )
                    }}
                  />
                </Col>
                <Col xs={24} sm={24} md={8} lg={8}>
                  <ErrorMessage error={errors[schema.subDistrict.name]} />
                  <ControlLabel>
                    {requiredFiled(schema.subDistrict.validators, schema.subDistrict.label)}
                  </ControlLabel>
                  <Controller
                    key={schema.subDistrict.name}
                    name={schema.subDistrict.name}
                    control={control}
                    rules={isValidators(schema.subDistrict.validators)}
                    defaultValue={schema.subDistrict.value}
                    render={(props) => {
                      return (
                        <SelectPicker
                          size="lg"
                          data={subDistrict}
                          style={{ width: '100%' }}
                          value={props.value}
                          placeholder={`เลือก${schema.subDistrict.label}`}
                          onSelect={(value) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>
              <br />
              {schema.footer}
            </FormGroup>
          </Form>
          {isLoading && <OverlayLoader />}
        </Panel>
      )}
    </>
  )
}
